export default function downloadPDF(url: string, filename: string) {
  fetch(url)
    .then(response => {
      if (response.headers.get('content-type') === 'application/pdf') return response.blob();
      throw TypeError('Code not found.');
    })
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Error downloading PDF:', error);
    });
}
